import { render, staticRenderFns } from "./TabBlock.vue?vue&type=template&id=58f1e07e"
import script from "./TabBlock.vue?vue&type=script&lang=js"
export * from "./TabBlock.vue?vue&type=script&lang=js"
import style0 from "./TabBlock.vue?vue&type=style&index=0&id=58f1e07e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports